import { Injectable, Injector } from '@angular/core';
import { ToastHostComponent, Toast, ToastOptions } from 'components/toast/toast-host';
import { SettingsService } from 'services/settings.service';

@Injectable()
export class ToastController {
  toastHost: ToastHostComponent = undefined;

  // This is a queue of toasts that are requested before the toast host is ready.
  preBootQueue: ToastOptions[] = [];

  constructor(private injector: Injector) {}

  public registerHost(host: ToastHostComponent) {
    this.toastHost = host;
    // show all the toasts that were requested before the host was ready
    for (let opts of this.preBootQueue) {
      this.toastHost.addToast(opts);
    }
    this.preBootQueue = [];
  }

  isReady() {
    return this.toastHost !== undefined && typeof this.toastHost.addToast === 'function';
  }

  public showToast(opts: ToastOptions): Toast {
    // if toast has uniqueId and user has permanently dismissed it, don't show it
    if (opts.uniqueId) {
      const settings = this.injector.get(SettingsService);
      if (settings.isToastDismissed(opts.uniqueId)) {
        return undefined;
      }
    }

    // If the host is not ready
    if (!this.isReady()) {
      // queue the toast for later.
      this.preBootQueue.push(opts);
      return undefined;
    }
    return this.toastHost.addToast(opts);
  }

  public dismissToast(toast: Toast) {
    this.toastHost.dismissToast(toast);
  }
}
